module.exports = __webpack_public_path__ + "img/multiple.9a34e829.svg";